import {
    CHAT_TYPE,
    ChatType,
} from '../../../../communities/components/Chats/interface/chats.interface';

export const typeLabels: Record<ChatType, string> = {
    [CHAT_TYPE.CHANNEL]: 'Канал',
    [CHAT_TYPE.GROUP]: 'Группа',
    [CHAT_TYPE.SUPERGROUP]: 'Группа',
};
